import React, { Component } from "react";
import Layout from "../../HOC/Layput/Layout";
import * as actions from "../../Store/Actions/index";
import { Form, Row, Col, Button, } from "react-bootstrap";
import { connect } from "react-redux";
import Axios from "../../axios-instance";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Spinner from '../../Components/UI/Spinner/Spinner'
class SampleCopy extends Component {
  state = {
    name: "",
    email: "",
    phone: null,
    InstitutionName: "",
    class: "",
    classID: null,
    boards: "",
    board_ID: null,
    books: "",
    bookID: null,
    fetchedBooks: [],
    selectBoards: true,
    payload: [],
    btnDisabled: true,
  };

  componentDidMount() {
    this.props.getGrade();
    this.props.getBoard();
  }

  getGradeId = (id) => {
    let grade = id.target.value.split("&&");
    let gradeID = grade[0];
    let gradename = grade[1];
    this.setState({
      class: gradename,
      classID: gradeID,
      selectBoards: false,
    });
  };
  
  boardsID = (id) => {
    let boards = id.target.value.split("&&");
    let boardsID = boards[0];
    let boardsname = boards[1];
    this.setState({
      boards: boardsname,
      board_ID: boardsID,
    });
    Axios.get(`/get/vk/books/${this.state.classID}/${boardsID}`).then(
      (response) => {
        this.setState({
          fetchedBooks: response.data,
        });
      }
    );
  };
  getBookID = (book) => {
    this.setState({
      bookID: book[0].book_id,
    });
  };
  saveData = (event) => {
    // const { name, value } = event.target;
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  submitData = (event) => {
    event.preventDefault();
    let userData = {
      full_name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      institution_name: this.state.InstitutionName,
      class_id: this.state.classID,
      board_id: this.state.board_ID,
      book_id: this.state.bookID,
    };
    this.setState({
      payload: userData,
    });

    this.props.GetSampleCopy(userData)
  };

  render() {
  document.title = "VK Global Publications | Sample Copy"

    let loader = this.props.loading ? <Spinner /> : ''
    return (
      <div>
        {loader}
        <Form>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Name "
              name="name"
              onChange={this.saveData}
            />
          </Form.Group>
          <Row>
            <Col md={6}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  onChange={this.saveData}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Phone"
                  name="phone"
                  onChange={this.saveData}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Institution Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Institution Name "
              name="InstitutionName"
              onChange={this.saveData}
            />
          </Form.Group>
          <Row>
            <Col md={4}>
              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label>Class </Form.Label>
                <Form.Control
                  as="select"
                  name="class"
                  onChange={this.getGradeId}
                >
                  <option selected disabled>
                    Choose Grade
                  </option>
                  {this.props.classList.map((grade, index) => {
                    return (
                      <option
                        value={grade.id + "&&" + grade.class_name}
                        key={index}
                      >
                        {grade.class_name}
                      </option>
                    );
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label>Boards </Form.Label>
                <Form.Control
                  disabled={this.state.selectBoards}
                  as="select"
                  name="boards"
                  onChange={this.boardsID}
                >
                  <option selected disabled>
                    Choose Boards
                  </option>
                  {this.props.boardList.map((board, index) => {
                    return (
                      <option
                        value={board.id + "&&" + board.board_name}
                        key={index}
                      >
                        {board.board_name}
                      </option>
                    );
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Label>Books </Form.Label>
                <Typeahead
                  id="basic-typeahead-example"
                  disabled={this.state.fetchedBooks.length === 0}
                  labelKey="title"
                  value="id"
                  onChange={this.getBookID}
                  placeholder={
                    this.state.fetchedBooks.length === 0
                      ? "No Books Found"
                      : "Choose a Book..."
                  }
                  options={this.state.fetchedBooks}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <Button
          // disabled={this.state.btnDisabled}
          className="submitBtn mt-4"
          onClick={this.submitData}
        >
          Submit
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    classList: state.filterMenu.gradeList,
    subjectList: state.filterMenu.subjectList,
    boardList: state.filterMenu.boardList,
    loading: state.book.loading,
    fetchedBooks: state.book.booksFetched,
  };
};
const mapDispatchToprops = (dispatch) => {
  return {
    getGrade: () => dispatch(actions.fetchGradeList()),
    getBoard: () => dispatch(actions.fetchBoardList()),
    GetSampleCopy: (payload) => dispatch(actions.GetSampleCopy(payload)),
  };
};

export default Layout(
  connect(mapStateToProps, mapDispatchToprops)(SampleCopy),
  "  Request Free Sample Copy "
);
